import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeathIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.99973 1C10.485 1 12.4997 3.01472 12.4997 5.5V13.2393L14.1228 13.5098C14.5313 13.5778 14.8079 13.9646 14.74 14.373C14.6719 14.7815 14.2851 15.0581 13.8767 14.9902L11.4929 14.5928C9.18015 14.2074 6.81931 14.2073 4.50657 14.5928L2.12278 14.9902C1.71444 15.0579 1.32756 14.7814 1.2595 14.373C1.19165 13.9647 1.46841 13.578 1.87669 13.5098L3.49973 13.2393V5.5C3.49973 3.01483 5.51461 1.00018 7.99973 1ZM7.99973 3C7.58567 3.00018 7.24973 3.3359 7.24973 3.75V4.5H6.49973C6.08567 4.50018 5.74973 4.8359 5.74973 5.25C5.74973 5.6641 6.08567 5.99982 6.49973 6H7.24973V8C7.24973 8.4141 7.58567 8.74982 7.99973 8.75C8.41395 8.75 8.74973 8.41421 8.74973 8V6H9.49973C9.91395 6 10.2497 5.66421 10.2497 5.25C10.2497 4.83579 9.91395 4.5 9.49973 4.5H8.74973V3.75C8.74973 3.33579 8.41395 3 7.99973 3Z",
		fill: "currentColor",
		stroke: "none"
	})
});
export default SvgDeathIcon;
